const branchesData = [
	{
		isActive: true,
		id: 'branch-1',
		title: {
			da: 'Industribranchen',
			en: 'Production'
		}
	},
	{
		isActive: true,
		id: 'branch-2',
		title: {
			da: 'Hotel- og restaurationsbranchen',
			en: 'Restaurants'

		}
	}
];



export {
	branchesData
};